<template>
  <v-card flat>
    <v-card-text>
      <!-- Summary Cards -->
      <v-row v-if="report" class="mb-4">
        <v-col cols="6" sm="3">
          <v-card color="blue darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.total_technicians }}
            </div>
            <div class="caption">Total Technicians</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card color="indigo darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.grand_total_problems }}
            </div>
            <div class="caption">Total Problems</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card color="green darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.grand_total_completed }}
            </div>
            <div class="caption">Completed</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card color="orange darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.grand_total_pending }}
            </div>
            <div class="caption">Pending</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Data Table -->
      <v-data-table
        v-if="report"
        :items="report.items"
        :headers="headers"
        :search="search"
        dense
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search technicians..."
            dense
            class="mb-2"
          />
        </template>
        <template v-slot:item.completion_rate="{ item }">
          <v-chip :color="getCompletionColor(item.completion_rate)" dark small>
            {{ item.completion_rate }}%
          </v-chip>
        </template>
        <template v-slot:item.avg_turnaround_hours="{ item }">
          {{
            item.avg_turnaround_hours !== null
              ? item.avg_turnaround_hours + " hrs"
              : "N/A"
          }}
        </template>
        <template v-slot:item.avg_turnaround_days="{ item }">
          {{
            item.avg_turnaround_days !== null
              ? item.avg_turnaround_days + " days"
              : "N/A"
          }}
        </template>
      </v-data-table>

      <!-- Empty State -->
      <div v-if="!report" class="text-center grey--text pa-10">
        <v-icon size="64" color="grey lighten-1">mdi-account-hard-hat</v-icon>
        <p class="mt-4 subtitle-1">
          Click "Generate" to see technician performance metrics.
        </p>
        <p class="caption grey--text">
          Uses the date range from the filters above. Default: last 30 days.
        </p>
      </div>

      <!-- No Results -->
      <div
        v-if="report && report.items && report.items.length === 0"
        class="text-center pa-10"
      >
        <v-icon size="64" color="grey">mdi-account-off</v-icon>
        <p class="mt-4 subtitle-1 grey--text">
          No technician data found for the selected period.
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "TechnicianPerformance",
  props: {
    filters: { type: Object, required: true },
  },
  data() {
    return {
      report: null,
      search: "",
      headers: [
        { text: "Technician", value: "technician" },
        { text: "Total Problems", value: "total_problems", align: "center" },
        { text: "Completed", value: "completed", align: "center" },
        { text: "Pending", value: "pending", align: "center" },
        { text: "Completion Rate", value: "completion_rate", align: "center" },
        {
          text: "Avg Turnaround (hrs)",
          value: "avg_turnaround_hours",
          align: "center",
        },
        {
          text: "Avg Turnaround (days)",
          value: "avg_turnaround_days",
          align: "center",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      fetchReport: "service_reports/get_technician_performance_report",
    }),
    getCompletionColor(rate) {
      if (rate >= 80) return "green";
      if (rate >= 50) return "orange";
      return "red";
    },
    async generate() {
      try {
        let params = {};
        if (this.filters.from_date) params.from_date = this.filters.from_date;
        if (this.filters.to_date) params.to_date = this.filters.to_date;
        if (this.filters.branch_id) params.branch_id = this.filters.branch_id;
        let data = await this.fetchReport(params);
        this.report = data;
      } catch (e) {
        this.$alert({
          title: "Error",
          message:
            "Error generating technician performance: " +
            (e.response?.data?.error || e.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
  },
};
</script>
